import React from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import EmojiFoodBeverageIcon from "@material-ui/icons/EmojiFoodBeverage";

const useStyles = makeStyles((theme) => ({
  centerText: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: "70vh",
  },
}));

export default function ErrorPageComingSoon() {
  const classes = useStyles();

  return (
    <div className={classes.centerText}>
      <div style={{ display: "flex" }}>
        <EmojiFoodBeverageIcon style={{ fontSize: "80px" }} />
      </div>
      <div style={{ display: "flex" }}>
        <Typography
          variant="h2"
          gutterBottom
          style={{ fontFamily: "Sacramento, cursive", textAlign: "center" }}
        >
          Coming Soon!
        </Typography>
      </div>
      <div style={{ display: "flex", textAlign: "center" }}>
        <Typography variant="h6" gutterBottom>
          This feature is coming soon. Meanwhile, enjoy a cup of tea!!!
        </Typography>
      </div>
    </div>
  );
}
